// TODO: Refactor Page / Tab loading to use react-router instead of hardcoded tabs (no need for this provider then)

import React, { createContext, FC, ReactNode, useContext, useState } from "react";

interface ClimateActionUIContextType {
  showCreateChildClimateActionView: boolean;
  setShowCreateChildClimateActionView: React.Dispatch<React.SetStateAction<boolean>>;
  isEditing: boolean;
  toggleEditViewMode: () => void;
}

const ClimateActionUIContext = createContext<ClimateActionUIContextType | undefined>(undefined);

// Define a type for the props that the provider will accept
interface ClimateActionUIContextProviderProps {
  children: ReactNode;
}

// Create the provider component
export const ClimateActionUIContextProvider: FC<ClimateActionUIContextProviderProps> = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);

  const [showCreateChildClimateActionView, setShowCreateChildClimateActionView] = useState(false);

  const toggleEditViewMode = () => {
    setIsEditing(!isEditing);
  };

  return (
    <ClimateActionUIContext.Provider
      value={{
        showCreateChildClimateActionView,
        setShowCreateChildClimateActionView,
        isEditing,
        toggleEditViewMode,
      }}
    >
      {children}
    </ClimateActionUIContext.Provider>
  );
};

// Define the useClimateActionUIState hook
export const useClimateActionUIState = (): ClimateActionUIContextType => {
  const context = useContext(ClimateActionUIContext);

  if (!context) {
    throw new Error("useClimateActionUIState must be used within a ChildProvider");
  }

  return context;
};
